import { render, staticRenderFns } from "./privacy-policy-com.vue?vue&type=template&id=078d1862&scoped=true"
import script from "./privacy-policy-com.vue?vue&type=script&lang=js"
export * from "./privacy-policy-com.vue?vue&type=script&lang=js"
import style0 from "./privacy-policy-com.vue?vue&type=style&index=0&id=078d1862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078d1862",
  null
  
)

export default component.exports